export const taskOptions = [
  {
    name: "Call",
    value: "call",
  },
  {
    name: "Email",
    value: "email",
  },
  {
    name: "Message",
    value: "message",
  },
  {
    name: "Follow Up",
    value: "follow_up",
  },
  {
    name: "Send",
    value: "send",
  },
  {
    name: "Video Call",
    value: "video_call",
  },
];

export const repeatOptions = [
  {
    name: "Don't Repeat",
    value: "NoRepeat",
  },
  {
    name: "Everyday",
    value: "everyday",
  },
  {
    name: "Weekly",
    value: "weekly",
  },
  {
    name: "Monthly",
    value: "monthly",
  },
  {
    name: "Yearly",
    value: "yearly",
  },
  {
    name: "Custom (Days)",
    value: "custom",
  },
];

export const taskDueDates = [
  {
    name: "Today",
    value: "today",
  },
  {
    name: "Tomorrow",
    value: "tomorrow",
  },
  {
    name: "3 Days From Now",
    value: "3d",
  },
  {
    name: "1 Week From Now",
    value: "1w",
  },
  {
    name: "1 Month From Now",
    value: "1m",
  },
  {
    name: "Custom Date",
    value: "custom",
  },
];

export const taskDueDatesValues = {
  today: "0",
  tomorrow: "1",
  "3d": "3",
  "1w": "7",
  "1m": "30",
};

// ⚠️ DEPRECATED: dashboardDates removed - use DASHBOARD_DATE_OPTIONS from dashboardManager.ts
// All dashboard components now use the centralized DashboardDateManager

export const automationActionData = [
  {
    name: "Create task",
    value: "create_task",
    isSelected: false,
  },
  {
    name: "Change status",
    value: "status_change",
    isSelected: false,
  },
  {
    name: "Change Label",
    value: "label_change",
    isSelected: false,
  },
  {
    name: "Move to list",
    value: "move_to_list",
    isSelected: false,
  },
  {
    name: "Copy to list",
    value: "copy_to_list",
    isSelected: false,
  },
  {
    name: "Send notification",
    value: "push_notification",
    isSelected: false,
  },
  {
    name: "Assign lead",
    value: "assign_lead",
    isSelected: false,
  },
  {
    name: "Send Email (brevo)",
    value: "send_email",
    isSelected: false,
  },
  {
    name: "Send Gmail",
    value: "send_gmail",
    isSelected: false,
  },
  {
    name: "Send ZeptoMail",
    value: "send_zeptomail",
    isSelected: false,
  },
  {
    name: "Send Whatsapp",
    value: "send_whatsapp",
    isSelected: false,
  },
  {
  value: "add_to_google_sheet",
  name: "Add to Google Sheet"
},
{
  value: "add_facebook_audience",
  name: "Add to Facebook Audience"
},
{
  value: "webhook",
  name: "Send Webhook",
  isSelected: false
}
];

export const automationWhenTriggerData = [
  {
    name: "New lead is created",
    value: "create_lead",
  },
  {
    name: "Lead is edited",
    value: "edit_lead",
  },
  {
    name: "Status is updated",
    value: "status_change",
  },
  {
    name: "Label is updated",
    value: "label_change",
  },
   {
    value: "task_due_date",
    name: "Task Due Date"
  },
  {
    value: "task_completed", 
    name: "Task Completed"
  },
  {
    name: "Page is viewed",
    value: "viewed",
  },
  {
    name: "File is viewed",
    value: "viewed",
  },
  {
    name: "Quotation created",
    value: "create_quotation",
  },
  {
    name: "Quotation edited",
    value: "edit_quotation",
  },
  {
    name: "Create task",
    value: "create_task",
  },
  {
    name: "Task is edited",
    value: "edit_task",
  },
  {
    name: "Activity is created",
    value: "create_activity",
  },
  {
    name: "Incoming call activity",
    value: "create_incoming_activity",
  },
  {
    name: "Outgoing call activity",
    value: "create_outgoing_activity",
  },
  {
    name: "Missed call activity",
    value: "create_miscalled_activity",
  },
  {
    name: "New lead added to list",
    value: "new_lead_added",
  },
  { name: "Call Duration Threshold", value: "call_duration" },
{ name: "Call Count Threshold", value: "call_count" },
{ name: "Invoice is Created", value: "create_invoice" },
{ name: "Order is Created", value: "create_order" },
{ value: "edit_invoice", name: "Invoice is Edited" },
{ value: "edit_order", name: "Order  is Edited" }
];


export const TIME_BASED_EVENTS = ['task_due_date', 'task_completed'];

// Events that need task type selection
export const TASK_TYPE_EVENTS = [
  'create_task',
  'edit_task', 
  'task_due_date',
  'task_completed'
];

// Field mapping for time-based events
export const TIME_FIELD_MAPPING = {
  'task_due_date': 'toBePerformAt',
  'task_completed': 'completedAt'
};

export const customActivityType = [
  {
    name: "Incoming",
    value: "INCOMING",
  },
  {
    name: "Outgoing ",
    value: "OUTGOING",
  },
  {
    name: "Missed",
    value: "MISSED",
  },
  {
    name: "share",
    value: "share",
  },
  {
    name: "Viewed",
    value: "viewed",
  },
  {
    name: "Status Update",
    value: "status_updated",
  },
  {
    name: "Task Created",
    value: "task_created",
  },
  {
    name: "Task Updated",
    value: "task_updated",
  },
  {
    name: "Task Assigned",
    value: "task_assigned",
  },
  {
    name: "Task Completed",
    value: "task_completed",
  },
  {
    name: "Auto lead assigned",
    value: "auto_lead_assign",
  },
  {
    name: "Note Created",
    value: "note_created",
  },
  {
    name: "Quotation created",
    value: "quotation_created",
  },
  {
    name: "Quotation approved",
    value: "quotation_approved",
  },
  {
    name: "Lead copied",
    value: "lead_copied",
  },
  {
    name: "Lead moved",
    value: "lead_moved",
  },
  {
    name: "Lead details updated",
    value: "lead_details_updated",
  },
  {
    name: "Voice Note",
    value: "new_voice_note",
  },
  {
    name: "Lead score update",
    value: "lead_score_update",
  },
];
